import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.svg`
  width: var(--icon-size);
  height: var(--icon-size);
`;

interface Props {
  className?: string;
  opacity?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  fill?: string;
}

export const CheckIcon: React.FC<Props> = ({
  onClick,
  className,
  opacity = "0.38",
  style,
  fill,
}) => {
  return (
    <StyledRoot
      style={style}
      className={className}
      onClick={onClick}
      focusable="false"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M9.00003 16.17L4.83003 12L3.41003 13.41L9.00003 19L21 7L19.59 5.59L9.00003 16.17Z"
        fillOpacity={opacity}
        fill={fill ?? "var(--green)"}
      />
    </StyledRoot>
  );
};
